import React from 'react';
import classnames from 'classnames';
import baseStyles from 'custom/base.styl';

const PASSING_SCORE = 21;

const LanguageTestFailedOverview = ({ score, timeout }) => {
  return (
    <div>
      {!timeout &&
        <h3 className={classnames(baseStyles.title_small, baseStyles.text_danger, baseStyles.left, baseStyles.mb_15)}>You have failed the language test.</h3>
      }
      {!!timeout &&
        <h3 className={classnames(baseStyles.title_small, baseStyles.text_danger, baseStyles.left, baseStyles.mb_15)}>You’ve run out of time</h3>
      }
      <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}>
        You've scored <b>{score}</b> out of 24, while the passing score is {PASSING_SCORE}.
      </p>
      <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}><b>Please note:</b> per our company policy, we cannot share our test questions, as well as correct answers to it.</p>
      <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}>
        Unfortunately, we cannot offer you a position right now. Please improve your English skills and we will be glad to see you reapplying in the next 3 months.
      </p>
    </div>
  );
};

export default LanguageTestFailedOverview;



// WEBPACK FOOTER //
// ./src/components/ApplicationOverview/LanguageTestFailedOverview.js